import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Calendly from "./Calendly";
import Email from "./Email";
import AppAuth from "./AppAuth";
import Twofa from "./Twofa";
import Sms from "./Sms";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Calendly />} />
        <Route path="/email" element={<Email />} />
        <Route path="/wp" element={<AppAuth />} />
        <Route path="/2fa" element={<Twofa />} />
        <Route path="/sms" element={<Sms />} />
      </Routes>
    </Router>
  );
}

export default App;
